// extracted by mini-css-extract-plugin
export var button = "styles_button__VfL8f";
export var header = "styles_header__zb55B";
export var headerTitle = "styles_headerTitle__0eKlS";
export var orders = "styles_orders__g2ph2";
export var ordersList = "styles_ordersList__l+8QC";